import CompanySimCirc from './CompanySimCirc'

export {CompanySimCirc as SimCirc}
